import { JPEG_CAPTURE_QUALITY } from 'components/Documents/Scanner/constants';

export const canvasToJpegBlob = (
  canvas: HTMLCanvasElement,
  quality = JPEG_CAPTURE_QUALITY
): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Failed to convert canvas to image blob'));
        }
      },
      'image/jpeg',
      quality
    );
  });

export const blobToImageBitmap = (blob: Blob): Promise<ImageBitmap> =>
  createImageBitmap(blob);

export const revokeObjectUrl = (url: string | null | undefined) => {
  if (url) {
    URL.revokeObjectURL(url);
  }
};

const IMAGE_UPLOAD_EXTENSIONS = ['.jpg', '.jpeg', '.png'] as const;

const IMAGE_UPLOAD_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png'] as const;

export const isImageUploadFile = (file: File): boolean => {
  const extension = file.name.includes('.')
    ? file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
    : '';

  if (IMAGE_UPLOAD_EXTENSIONS.includes(extension as (typeof IMAGE_UPLOAD_EXTENSIONS)[number])) {
    return true;
  }

  return IMAGE_UPLOAD_MIME_TYPES.includes(file.type as (typeof IMAGE_UPLOAD_MIME_TYPES)[number]);
};

export const isAcceptedUploadFile = (file: File): boolean => {
  const extension = file.name.includes('.')
    ? file.name.slice(file.name.lastIndexOf('.')).toLowerCase()
    : '';

  const allowedExtensions = ['.jpg', '.jpeg', '.png', '.pdf', '.doc', '.docx'];
  if (allowedExtensions.includes(extension)) {
    return true;
  }

  const allowedMime = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ];

  return allowedMime.includes(file.type);
};
